import {
  keepPreviousData,
  queryOptions,
  useQuery
} from '@tanstack/react-query';

import type { GetPeopleBillLogQuery } from '@schema/cart';

import API from '@api';
import { ELEMENTS_BONUSES_LK } from '@constants/ElementsLimit';

export type PeopleBillLogT = GetPeopleBillLogQuery['getPeopleBillLog'];

export const BILL_LOG_QUERY_KEY = 'peopleBillLog';

export const peopleBillLogQueryOptions = (page = 1) =>
  queryOptions({
    queryKey: [BILL_LOG_QUERY_KEY, page],
    queryFn: () =>
      API.getPeopleBillLog({ page, setLimit: ELEMENTS_BONUSES_LK }).then(
        res => res.getPeopleBillLog
      ),
    placeholderData: keepPreviousData
  });

export const usePeopleBillLogQuery = (page?: number) =>
  useQuery(peopleBillLogQueryOptions(page));

export const PEOPLE_BILL_AMOUNT_QUERY_KEY = 'peopleBillAmount';

/**
 * Бонусный счёт + профиль лояльности (status_id, can_invite). Один кэш на
 * статус лояльности в UserStore и блоки «пригласи друга» (главная,
 * «спасибо за покупку», личный кабинет).
 */
export const peopleBillAmountQueryOptions = () =>
  queryOptions({
    queryKey: [PEOPLE_BILL_AMOUNT_QUERY_KEY],
    queryFn: () =>
      API.getPeopleBillAmount().then(res => res.getPeopleBillAmount ?? null),
    staleTime: 60 * 1000,
    gcTime: 5 * 60 * 1000
  });
